"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ClipboardAttachmentSolid: function() {
        return ClipboardAttachmentSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ClipboardAttachmentSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.79289 1.79289C8.30057 1.28521 8.98914 1 9.70711 1H14.2929C15.0109 1 15.6994 1.28521 16.2071 1.79289C16.5444 2.13022 16.7835 2.5474 16.906 3H18C19.6569 3 21 4.34315 21 6V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V6C3 4.34315 4.34315 3 6 3H7.09397C7.21646 2.5474 7.45557 2.13022 7.79289 1.79289ZM14.7929 3.20711C14.9255 3.33972 15 3.51957 15 3.70711V5H9V3.70711C9 3.51957 9.0745 3.33972 9.20711 3.20711C9.33972 3.0745 9.51957 3 9.70711 3H14.2929C14.4804 3 14.6603 3.0745 14.7929 3.20711ZM13 11C13 10.7239 13.2239 10.5 13.5 10.5C13.7761 10.5 14 10.7239 14 11V15.5C14 16.6046 13.1046 17.5 12 17.5C10.8954 17.5 10 16.6046 10 15.5V11.5C10 10.9477 9.55228 10.5 9 10.5C8.44772 10.5 8 10.9477 8 11.5V15.5C8 17.7091 9.79086 19.5 12 19.5C14.2091 19.5 16 17.7091 16 15.5V11C16 9.61929 14.8807 8.5 13.5 8.5C12.1193 8.5 11 9.61929 11 11V15.5C11 16.0523 11.4477 16.5 12 16.5C12.5523 16.5 13 16.0523 13 15.5V11Z",
        fill: "currentColor"
    })
}), "ClipboardAttachmentSolid");
const _default = ClipboardAttachmentSolid;
